"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _dateUtils = require("../dateUtils");

var _jalaaliJs = _interopRequireDefault(require("jalaali-js"));

var _Icons = require("./Icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var jalaaliYearArray = [],
    gregorianYearArray = [];
{
  var now = new Date();

  var j = _jalaaliJs.default.toJalaali(now);

  var n = j.jy + 20;

  for (var i = 1370; i < n; i++) {
    jalaaliYearArray.push({
      year: i,
      yearString: (0, _dateUtils.mapToFarsi)(i)
    });
  }

  n = now.getFullYear() + 20;

  for (var _i = 1980; _i < n; _i++) {
    gregorianYearArray.push({
      year: _i,
      yearString: (0, _dateUtils.mapToFarsi)(_i)
    });
  }
}

var Years = /*#__PURE__*/function (_React$Component) {
  _inherits(Years, _React$Component);

  var _super = _createSuper(Years);

  function Years(props) {
    var _this;

    _classCallCheck(this, Years);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "nextYear", function (e) {
      e.preventDefault();

      _this.props.changeEvent(_this.props.year + 1);
    });

    _defineProperty(_assertThisInitialized(_this), "prevYear", function (e) {
      e.preventDefault();

      _this.props.changeEvent(_this.props.year - 1);
    });

    _defineProperty(_assertThisInitialized(_this), "nextDecade", function (e) {
      e.preventDefault();

      _this.props.changeEvent(_this.props.year + 10);
    });

    _defineProperty(_assertThisInitialized(_this), "prevDecade", function (e) {
      e.preventDefault();

      _this.props.changeEvent(_this.props.year - 10);
    });

    _this.state = {};
    return _this;
  }

  _createClass(Years, [{
    key: "render",
    value: function render() {
      var year = this.props.year;
      var yearString = (0, _dateUtils.mapToFarsi)(year);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "JC-Section JC-Section-Year"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "JC-Nav JC-Nav-Year",
        onClick: this.prevDecade
      }, /*#__PURE__*/_react.default.createElement(_Icons.DoublePreviousIcon, null)), /*#__PURE__*/_react.default.createElement("div", {
        className: "JC-Nav JC-Nav-Year",
        onClick: this.prevYear
      }, /*#__PURE__*/_react.default.createElement(_Icons.PreviousIcon, null)), /*#__PURE__*/_react.default.createElement("span", {
        className: "JC-Title"
      }, yearString), /*#__PURE__*/_react.default.createElement("div", {
        className: "JC-Nav JC-Nav-Year",
        onClick: this.nextYear
      }, /*#__PURE__*/_react.default.createElement(_Icons.NextIcon, null)), /*#__PURE__*/_react.default.createElement("div", {
        className: "JC-Nav JC-Nav-Year",
        onClick: this.nextDecade
      }, /*#__PURE__*/_react.default.createElement(_Icons.DoubleNextIcon, null)));
    }
  }]);

  return Years;
}(_react.default.Component);

var _default = Years;
exports.default = _default;